import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fromStore, modalsSelector } from "../../selectors";
import { withRouter  } from 'react-router-dom';
import { setActiveModalAction } from "../../action";
import { useOnClickOutside } from "../../hooks";
import { addProductCategory, deleteProductCategory, updateProductCategory } from "../../action/raw";
import swal from 'sweetalert';
import cn from 'classnames';
import ErrorContainer from "../../components/utils/ErrorContainer";
import Switch from "../../components/utils/Switch";


function ProductCategoryModal() {
    const ref = useRef();
    const dispatch = useDispatch();
    const id = useSelector(modalsSelector).productCategory.id;
    const type = useSelector(modalsSelector).productCategory.type;
    const loading = useSelector(fromStore.loaderModalCategoryRawSelector);
    const category = useSelector(fromStore.categoryRawById(id));
    const [confirmDelete, setConfirmDelete] = useState(false);

    const initData = category ? {
        title: category.title,
        type: category.type,
        notBalance: category.notBalance,
    } : {
        title: '',
        type,
        notBalance: false,
    };
    const [data, setData] = useState(initData);
    const isEditMode = id !== 'new';

    const onChangeInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.target.value;
        setData(updated);
    };
    
    const onChangeSwitch = (field, value) => {
      const updated = {...data};
        updated[field] = value;
        setData(updated);
    }

    const onDelete = (id) => () => {
        setConfirmDelete(true);
        swal({
            title: `Удаление категории`,
            text: `Вы действительно хотите удалить категорию?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) dispatch(deleteProductCategory(id));
            setConfirmDelete(false);
        });
    }
    
    const onClose = () => !loading && dispatch(setActiveModalAction({ field: 'productCategory', value: null }));
    useOnClickOutside(ref, () => !confirmDelete && onClose());

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isEditMode) {
          const result = await dispatch(addProductCategory(data));
          if (result) onClose();
        } else {
          const result = await dispatch(updateProductCategory(id, data));
          if (result) onClose();
        }
    };

    return (
        <form onSubmit={onSubmit}>
          <div  className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div ref={ref} className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{isEditMode ? 'Редактирование категории' : 'Добавление категории'} </h5>
                  <button onClick={onClose} type="button" className="close">
                  </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                      <label htmlFor="g-name" className="form-control-label">Название *</label>
                      <input disabled={loading} type="text" value={data.title} className="form-control" id="g-name" onChange={onChangeInput('title')} />
                    </div>
                    {data.type === 'raw' &&
                      <div>
                          <label className="col-10 col-form-label">Является упаковкой</label>
                          <div className="col-2">
                              <Switch
                                  onChange={(value) => onChangeSwitch('isPackaging', value)} 
                                  checked={data.notBalance} 
                              />
                          </div>
                      </div>
                    }
                    {data.type === 'semi' &&
                      <div>
                        <label className="col-10 col-form-label">Не имеет остатка на складе</label>
                          <div className="col-2">
                              <Switch
                                  onChange={(value) => onChangeSwitch('notBalance', value)} 
                                  checked={data.notBalance} 
                              />
                          </div>
                      </div>
                    }

                    <ErrorContainer field="productCategory" hasCloseButton={true}/>
                </div>
    
                <div className="modal-footer">
                  <button disabled={loading} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                  {isEditMode && (
                      <button
                      disabled={loading}
                      type="button"
                      onClick={onDelete(id)}
                      className={cn({ 'btn btn-danger kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loading })}>
                      Удалить</button>
                  )}
                  <button
                    type="submit"
                    disabled={!data || !data.title || loading}
                    className={cn({ 'btn btn-primary  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loading })}>
                      {isEditMode ? 'Сохранить' : 'Добавить категорию'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      );
}

export default withRouter(ProductCategoryModal);